// extracted by mini-css-extract-plugin
module.exports = {"root":"classes_root__2faXU","inverted-icon":"classes_inverted-icon__1pdzJ"};